export const _numTag = '0-9';
export const _searchDelay = 300;
export const _pageSize = 24;
